import { apiInstance } from './api';

/**
 * Retrieve configuration items (price, types, details, etc..)
 */
export const getItems = async ({
  country,
  postalCode,
  vendor,
  isB2B,
}: {
  country: string;
  postalCode: string;
  vendor?: string | undefined;
  isB2B: boolean;
}) =>
  apiInstance.get(`/getItems`, {
    params: { country, postalCode, vendor, b2bClient: isB2B },
  });
